import React from 'react';
import DashboardSvg from 'library/icons/dashboard.svg';
import { ImpersonationRow } from 'apps/admin/components/impersonation/styles';
import {
  impersonationMutation,
  impersonationMutationParseQuery,
} from 'apps/admin/queries/impersionationMutation';
import { NotificationRender } from 'library/components/notification';

const Impersonation = ({ userId, fontSize }) => {
  const impersonateUser = async () => {
    const logErrors = (errors) => {
      NotificationRender('error', 'There was an error');
      console.error(errors);
    };

    try {
      const { data } = await impersonationMutation(userId);
      const {
        success,
        errors,
        account,
      } = await impersonationMutationParseQuery(data);
      if (success) {
        NotificationRender(
          'success',
          `You have successfully logged in as ${account.first_name} ${account.last_name}`
        );
        window.location.href = `${window.location.origin}`;
      } else {
        logErrors(errors);
      }
    } catch (e) {
      logErrors(e);
    }
  };

  return (
    <ImpersonationRow onClick={impersonateUser} fontSize={fontSize}>
      <DashboardSvg />
      &nbsp;Impersonate
    </ImpersonationRow>
  );
};

Impersonation.defaultProps = {
  fontSize: '1em',
};

export default Impersonation;
